import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Swal from 'sweetalert2'

import DialogTitle from '@mui/material/DialogTitle'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import axios from 'axios'
import HeaderName from '../../HeaderName'
import { useSelector } from 'react-redux'
import { valueOf } from '../../../../assets/plugins/moment/src/lib/moment/to-type'
import Select from 'react-select';

export default function BankInfoDialog(props) {
  const token = localStorage.getItem('token')
  const url = process.env.REACT_APP_APP_URL
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  const [unitLists, setUnitLists] = useState([])
  const [type, setType] = useState('')
  const [subCategory, setSubCategory] = useState('')
  const [treatLists, setTreatLists] = useState([])

  const [conValue, setConValue] = useState('')

  const [value, setValue] = useState('')
  const [defineTotalAmount, setDefineTotalAmount] = useState('')
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [showValue, setShowValue] = useState(false)
  const [showItem, setShowItem] = useState(false)

  const [expDays, setExpDays] = useState(0)
  const [itemBaseQty, setItemBaseQty] = useState(0)

  const [showBody, setShowBody] = useState(false)
  const [batchList, setBatchList] = useState([])
  const [showExpDay, setShowExpDay] = useState(false)
  const [showItemBase, setShowItemBase] = useState(false)
  const [itemID, setItemID] = useState("")
  const [chooseUnitList, setChooseUnitList] = useState([])
  const [discountType, setDiscountType] = useState(false)
  const [conName, setConName] = useState('')
  const [selectedOptions, setSelectedOptions] = useState([]);
  // console.log(selectedOptions.map((i) => (i.value)), 'selectedOptions')
  //For Con Type
  const handleConType = name => {
    setConName(name)
  }

  //for Unit List
  const handleUnit = Id => {
    console.log(Id, 'Id')
    setChooseUnitList(
      unitLists.filter(
        el => el._id === Id
      )[0]
    )
  }

  //If FOCItem , Item
  const handleBodyPart = event => {
    console.log(event, 'i')
    setItemID(event)

  }
  const options = chooseUnitList?.relatedSubItems?.flatMap(option =>
    option.batches?.map(b => ({
      value: b._id,
      label: `${option?.relatedItem?.medicineItemName} (${option?.relatedItemUnit?.unitName || option?.relatedToUnit?.unitName}) (${b.relatedBranch?.name || "not set"}) (${b?.type || "not set"})`
    }))
  );


  //Type
  const handleType = event => {
    setType(event)
    if (event === 'Amount') {
      setShowValue(true)
      setShowItem(false)
    } else {
      setShowValue(true)
      setShowItem(false)
    }
  }
  const handleDiscountType = (value) => {
    setDiscountType(value)
    // if (value === 'Expired') {
    //   setShowExpDay(true)
    //   setShowItemBase(false)

    // } else {
    //   setShowItemBase(true)
    //   setShowExpDay(false)
    // }

  }
  //Create
  const DiscountCreate = () => {
    const data = {
      discountName: name,

      discountRate: type,
      description: description,
      discountValue: parseInt(value),
      discountType: discountType
    }
    if (discountType === 'Expired') {
      data.relatedUnitBatch = selectedOptions[0] && selectedOptions.map((i) => (i.value))
      data.expiredDay = expDays
    } else if (discountType === "Voucher") {
      data.certainAmount = parseInt(defineTotalAmount)

    } else {
      data.relatedUnitBatch = selectedOptions[0] && selectedOptions.map((i) => (i.value))
      data.itemBase = itemBaseQty
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    api
      .post('item-discounts', data, config)
      .then(function (response) {
        Swal.fire({
          title: 'Successful!',
          text: 'You Created Discount Data!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000
        })

        props.setDisLists([...props.disLists, response.data.data])
      })

      .catch(function (err) {
        Swal.fire({
          title: 'Something Wrong!',
          text: 'Error',
          icon: 'warning',
          showConfirmButton: false,
          timer: 2000
        })
      })
    props.close()
  }

  useEffect(() => {
    const getTreatmentList = async () => {
      try {
        const res = await api.get('medicine-lists')

        setTreatLists(res.data.list)

      } catch (err) { }
    }
    const getUnitList = async () => {
      try {
        const res = await api.get('medicine-items')

        setUnitLists(res.data.list)
        console.log(res.data.list, 'unit list')
      } catch (err) { }
    }

    const getBatches = async () => {
      try {
        const res = await api.get('item-discounts/batches')
        console.log(res.data.data)
        // setB(res.data.data)
      } catch (err) {
        alert(err.message)
      }
    }
    // // getCategory()
    getBatches()
    getUnitList()

    getTreatmentList()
  }, [])

  return (
    <div>
      <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='sm'>
        <DialogTitle>
          <div className='modal-header ok'>
            <h4 className='modal-title'>Create Discount</h4>
            <button
              type='button'
              className='close'
              data-dismiss='modal'
              aria-label='Close'
              onClick={props.close}
            >
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          {/* @csrf */}
          <div class='modal-body'>
            <div class='form-group w-100'>
              <label for='name'>Name</label>
              <input
                type='text'
                class='form-control border border-info'
                name='name'
                placeholder='eg. mg mg'
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div class='form-group ml-1 w-100'>
              <label for='name'>Discount Type</label>
              <select
                class='custom-select border-info'
                name='account_type_id'
                id='cat'
                onChange={e => handleDiscountType(e.target.value)}
              >
                <option hidden>Choose</option>
                <option value='Voucher'>Voucher</option>
                <option value='Expired'>Expired Date</option>
                <option value='quantityBased'>Item Base</option>

              </select>
            </div>
            {discountType === "Expired" && (
              <div class='form-group  w-100'>
                <label for='name'>Expired Days</label>
                <input
                  type='number'
                  class='form-control border border-info'
                  name='name'
                  placeholder='Enter number'
                  onChange={e => setExpDays(e.target.value)}
                />
              </div>
            )}
            {discountType === "quantityBased" && (
              <div class='form-group  w-100'>
                <label for='name'>Item Base Quantity</label>
                <input
                  type='number'
                  class='form-control border border-info'
                  name='name'
                  placeholder='Enter number'
                  onChange={e => setItemBaseQty(e.target.value)}
                />
              </div>
            )}
            {discountType === "Voucher" && (
              <div class='form-group w-100'>
                <label for='name'>Certain Amount</label>
                <input
                  type='number'
                  class='form-control border border-info'
                  name='name'
                  placeholder='Enter number'
                  onChange={e => setDefineTotalAmount(e.target.value)}
                />
              </div>
            )}
            <div class='form-group ml-1 w-100'>
              <label for='name'>Discount Method</label>
              <select
                class='custom-select border-info'
                name='account_type_id'
                id='cat'
                onChange={e => handleType(e.target.value)}
              >
                <option hidden>Choose Type</option>

                <option value='Amount'>Amount</option>
                <option value='Percent'>Percent</option>

              </select>
            </div>
            {showValue && (
              <div class='form-group w-100'>
                <label for='name'>Value</label>
                <input
                  type='number'
                  class='form-control border border-info'
                  name='name'
                  placeholder='Enter number'
                  onChange={e => setValue(e.target.value)}
                />
              </div>
            )}
            {discountType !== "Voucher" && (
              <>
                {/* Item */}
                <div div class='form-group ml-1 w-100'>
                  <label for='name'>Item</label>
                  <select
                    class='custom-select border-info'
                    id='subCat'
                    name='account_type_id'
                    onChange={e => handleBodyPart(e.target.value)}
                  >
                    <option hidden>Choose</option>

                    {treatLists.map((item) => (
                      <option value={item._id}>{item?.name}</option>
                    ))}
                  </select>
                </div>

                {/* Sub-items */}
                <div class='form-group ml-1 w-100'>
                  <label for='name'>Sub Items</label>
                  <select
                    name='currency'
                    id=''
                    className='form-control mt-1'
                    onchange='convert(this.value)'
                    onChange={e => handleUnit(e.target.value)}
                  >
                    <option hidden>Choose</option>

                    {unitLists.filter(el => el.name?._id === itemID).map(option => (
                      <option value={option._id}>{option.medicineItemName}</option>
                    ))}
                  </select>
                </div>
                {/* Batches */}
                <div class='form-group ml-1 w-100'>
                  <label for='name'>Batches</label>

                  <Select
                    isMulti
                    options={options}
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    closeMenuOnSelect={false}
                    placeholder="Choose batches"
                  />
                </div>
              </>

            )}

            {/* {batchList[0] && (
              batchList.map((item, ind) => (
                <div className='row' kye={ind}>
                  <div className='col-2'></div>
                  <div className='col-8'></div>
                  <div className='col-2'></div>
                </div>
              ))

            )} */}
            {/* <div class='form-group'>
              <label for='name'>Start Date</label>
              <input
                type='date'
                class='form-control border border-info'
                name='name'
                placeholder='eg. mg mg'
                onChange={e => setStartDate(e.target.value)}
              />
            </div> */}

            {/* <div class='form-group'>
              <label for='name'>End Date</label>
              <input
                type='date'
                class='form-control border border-info'
                name='name'
                placeholder='eg. mg mg'
                onChange={e => setEndDate(e.target.value)}
              />
            </div> */}
            <div class='form-group ml-2 w-100'>
              <label for='name'>Description</label>
              <textarea
                className='form-control'
                id='description'
                onChange={e => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div class='modal-footer'>
            <Button
              class='btn btn-secondary'
              data-dismiss='modal'
              onClick={props.close}
            >
              Close
            </Button>
            <Button class='btn btn-primary' onClick={DiscountCreate}>
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
// phyo
//maymyat
